import authInstance from '../../utils/axios/authInstance';

// Rest password asked with email
export const passwordResetService = (data: any) => {
  return authInstance.post('/password/email', data);
}

//  Asking for reset password
export const passwordResetServiceSMS = (data: any) => {
  return authInstance.post('/password/phone', data);
}

// Verify attempt to reset password
export const verifyAttemptResetPasswordByPhoneNumberService = (data: object) => {
  return authInstance.post('/verify-password-reset-attempt', data);
}

// Reset password regular
export const passwordEnterService = (data: any) => {
  return authInstance.post('/password/reset', data);
}

// Reset password for phone users
export const resetPasswordForPhoneUsers = (data: object) => {
  return authInstance.post('/password/reset-phone', data);
}
